import Link from "next/link";
import Box from "@mui/material/Box"; // GLOBAL CUSTOM COMPONENTS

import HoverBox from "../../salify-next-layout/default/components/HoverBox";
import LazyImage from "../../salify-next-layout/default/components/LazyImage";
import { FlexBox } from "../../salify-next-layout/default/components/flex-box";
import DefaultCard from "../../salify-next-layout/default/components/Card";
import { H6, Span } from "../../salify-next-layout/default/components/Typography"; // CUSTOM UTILS LIBRARY FUNCTIONS

import { formatMoney } from "src/lib/utils/formatter";
import { calculateDiscount, toAssetImages } from "src/lib/utils";
import { Product } from "src/lib/fetcher/client";

// =======================================================
const FrequentlyProductCard = (props: Product) => {
  const {
    imageUrl = "/assets/images/products/Rectangle 116.png", // TODO add fallback img for product card
    salePrice,
    name,
    slugName,
  } = props;

  const discount = 0; // TODO move to product interface when available

  return (
    <DefaultCard
      sx={{
        p: 2,
        width: "100%",
        flex: "1 1 0",
        minWidth: "160px",
        margin: {
          xs: 0,
          sm: 1,
        },
        maxWidth: {
          xs: "100%",
          sm: "220px",
        },
      }}
    >
      <Link href={`/product/${slugName}`}>
        <HoverBox mb={1.5} borderRadius="8px">
          <LazyImage alt={name} width={500} height={500} src={toAssetImages(imageUrl)} />
        </HoverBox>

        <Span title={name} mb={0.5} color="inherit" ellipsis display="block">
          {name}
        </Span>

        <FlexBox alignItems="center" gap={1}>
          <H6 color="primary.main">{formatMoney(salePrice)}</H6>

          <Box component="del" fontWeight={600} color="grey.600">
            {calculateDiscount(salePrice, discount)}
          </Box>
        </FlexBox>
      </Link>
    </DefaultCard>
  );
};

export default FrequentlyProductCard;
